<template>
  <div>
    <Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
      <p slot="header" style="color:#0066FF;text-align:center">
        <Icon type="md-create"/>
        <span>用气设备注册--流速计算</span>
      </p>
      <p slot="close"></p>
      <div style="text-align:center">
        <Row class="row">
          <Col span="12">
            <p>天然气热值(MJ/m³)</p>
          </Col>
          <Col span="12">
            <Input readonly v-model="heatingValue" placeholder="请输入天然气热值" style="width: 150px"/>
          </Col>
        </Row>
        <Row class="row">
          <Col span="12">
            <p>倍率</p>
          </Col>
          <Col span="12">
            <Input readonly v-model="ratio" placeholder="请输入倍率" style="width: 150px"/>
          </Col>
        </Row>
        <Divider orientation="left">用气设备1</Divider>
        <Row class="row">
          <Col span="12">
            <p>额定压力(Pa)</p>
          </Col>
          <Col span="12">
            <Input v-model="pressure1" placeholder="请输入额定压力" style="width: 150px"/>
          </Col>
        </Row>
        <Row class="row">
          <Col span="12">
            <p>额定功率(kW)</p>
          </Col>
          <Col span="12">
            <Input v-model="ratedPower1" placeholder="请输入额定功率" style="width: 150px"/>
          </Col>
        </Row>
        <Divider orientation="left">用气设备2</Divider>
        <Row class="row">
          <Col span="12">
            <p>额定压力(Pa)</p>
          </Col>
          <Col span="12">
            <Input v-model="pressure2" placeholder="请输入额定压力" style="width: 150px"/>
          </Col>
        </Row>
        <Row class="row">
          <Col span="12">
            <p>额定功率(kW)</p>
          </Col>
          <Col span="12">
            <Input v-model="ratedPower2" placeholder="请输入额定功率" style="width: 150px"/>
          </Col>
        </Row>
        <Divider orientation="left">用气设备3</Divider>
        <Row class="row">
          <Col span="12">
            <p>额定压力(Pa)</p>
          </Col>
          <Col span="12">
            <Input v-model="pressure3" placeholder="请输入额定压力" style="width: 150px"/>
          </Col>
        </Row>
        <Row class="row">
          <Col span="12">
            <p>额定功率(kW)</p>
          </Col>
          <Col span="12">
            <Input v-model="ratedPower3" placeholder="请输入额定功率" style="width: 150px"/>
          </Col>
        </Row>
      </div>
      <div slot="footer">
        <Button type="info" size="large" long @click="calculation">录入</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  props: {
    callBack: {
      type: Function
    }
  },
  methods: {
    calculation() {
      if (parseFloat(this.ratedPower1).toString() == "NaN") {
        this.ratedPower1 = 32;
      }
      if (parseFloat(this.ratedPower2).toString() == "NaN") {
        this.ratedPower2 = 32;
      }
      if (parseFloat(this.ratedPower3).toString() == "NaN") {
        this.ratedPower3 = 32;
      }
      if (parseFloat(this.pressure1).toString() == "NaN") {
        this.pressure1 = 2000;
      }
      if (parseFloat(this.pressure2).toString() == "NaN") {
        this.pressure2 = 2000;
      }
      if (parseFloat(this.pressure3).toString() == "NaN") {
        this.pressure3 = 2000;
      }

      if (this.ratedPower1 == 0 || this.pressure1 == 0) {
        this.speed1 = 0;
      } else {
        this.speed1 =
          ((((this.ratedPower1 * 3.6) / this.heatingValue) *
            this.ratio *
            2000) /
            this.pressure1) *
          1000;
      }

      if (this.ratedPower2 == 0 || this.pressure2 == 0) {
        this.speed2 = 0;
      } else {
        this.speed2 =
          ((((this.ratedPower2 * 3.6) / this.heatingValue) *
            this.ratio *
            2000) /
            this.pressure2) *
          1000;
      }
      if (this.ratedPower3 == 0 || this.pressure3 == 0) {
        this.speed3 = 0;
      } else {
        this.speed3 =
          ((((this.ratedPower3 * 3.6) / this.heatingValue) *
            this.ratio *
            2000) /
            this.pressure3) *
          1000;
      }
      this.callBack();
    }
  },
  data() {
    return {
      modal8: true,
      heatingValue: global.gasApplianceHeatingValue,
      ratio: global.gasApplianceRatio,
      ratedPower1: 0,
      ratedPower2: 0,
      ratedPower3: 0,
      pressure1: 2000,
      pressure2: 2000,
      pressure3: 2000,
      speed1: 0,
      speed2: 0,
      speed3: 0
    };
  }
};
</script>
<style>
.row {
  margin: 5px;
  font-size: 15px;
}
</style>
